// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "scripts/referral-external/" + chunkId + ".chunk/" + {"490": "1847a323391c1283","860": "57e7a7da53e83163",}[chunkId] + ".js"
}